<template>
  <div>


    <template>
      <div>
        <div>
          <Button type="primary" @click="showEditDrawer(0)">添加</Button>
        </div>
        <!-- ...existing code... -->
      </div>
    </template>

    <div id="am_table">
      <Table row-key="id" :load-data="handleLoadData" :columns="columns16" :data="data" border></Table>
    </div>



    <!-- <div class="page">
    <Page :total="100" show-sizer />
       </div> -->

    <edit-form v-if="showEdit" :show-edit="showEdit" :id="editId" ref="editModel" @cancel-edit="closeEditDrawer"
      @edit-success="editSuccess">
    </edit-form>

  </div>
</template>

<script>
// import pageTable from "@/components/table/pageTable";
import editForm from "./edit";

export default {
  name: "lists",
  components: { editForm },
  data() {
    return {
      columns16: [
        {
          title: 'ID',
          key: 'id',
          tree: true

        },
        {
          title: '标题',
          key: 'title'
        },
        {
          title: '视频链接',
          key: 'file_url'
        },
        {
          title: '状态', key: 'status', render: (h, params) => {
            let status = parseInt(params.row.status);
            if (status === 1) {
              return h('span', '正常')
            } else {
              return h('Tag', { props: { type: 'error' } }, '禁用')
            }
          }
        },
        { title: '创建时间', key: 'create_time' },
        { title: '排序', key: 'sort' },
        { title: '修改时间', key: 'update_time' },
        {
          title: '操作', align: 'center', render: (h, params) => {
            let content = [];
            content.push(h('Button', {
              props: { type: 'primary', size: 'small', },
              style: { marginLeft: '5px' },
              on: {
                click: () => {
                  this.showEditDrawer(params.row.id)
                }
              }
            }, '编辑'))
            content.push(h('Button', {
              props: { type: 'error', size: 'small', },
              style: { marginLeft: '5px' },
              on: {
                click: () => {
                  this.del(params.row.id)
                }
              }
            }, '删除'))
            return h('div', content)
          }
        },

      ],
      data: [],
      // data13: [
      //   {
      //     id: '100',
      //     name: 'John Brown',
      //     age: 18,
      //     address: 'New York No. 1 Lake Park'
      //   },
      //   {
      //     id: '101',
      //     name: 'Jim Green',
      //     age: 24,
      //     address: 'London No. 1 Lake Park',
      //     _loading: false,
      //     children: [],


      //   },
      //   {
      //     id: '102',
      //     name: 'Joe Black',
      //     age: 30,
      //     address: 'Sydney No. 1 Lake Park'
      //   },
      //   {
      //     id: '103',
      //     name: 'Jon Snow',
      //     age: 26,
      //     address: 'Ottawa No. 2 Lake Park'
      //   }
      // ],
      showEdit: false,
      editId: 0,
      label: '',
      searchData: {
        mobile: '',
        name: '',
        day: '',
        type: 1,//司机端手册
      },

    }
  },
  methods: {
    handleLoadData() {
      // setTimeout(() => {
      //   const data = [
      //     {
      //       id: '10100',
      //       name: 'John Brown',
      //       age: 18,
      //       address: 'New York No. 1 Lake Park'
      //     },
      //     {
      //       id: '10101',
      //       name: 'Joe Blackn',
      //       age: 30,
      //       address: 'Sydney No. 1 Lake Park'
      //     }
      //   ];
      //   callback(data);
      // }, 2000);
    },
    showEditDrawer(id) {
      this.showEdit = true;
      this.editId = id
    },
    closeEditDrawer() {
      this.showEdit = false
      this.editId = 0
    },
    editSuccess() {
      // this.$refs.table.getInfo();
      this.getInfo();
      this.showEdit = false
    },
    async del(id) {
      this.$Modal.confirm({
        content: `确定要删除吗？`,
        loading: true,
        onOk: async () => {
          let res = await this.$commonFun.postProxy('admin/manual/delete', { id });
          this.$Modal.remove()
          this.$commonFun.successTip(res.msg, () => {
            this.getInfo();
          })
        },

      })



    },
    // async del(id) {
    //   let res = await this.$commonFun.postProxy('admin/advert/del', {id})
    //   this.$commonFun.dealApiResult(res, () => {
    //     this.$refs.table.getLists();
    //     this.$commonFun.successTip(res.msg)
    //   })
    // },
    async getInfo() {
      let res = await this.$commonFun.postProxy('admin/manual/getList', { type: 1 })
      this.$commonFun.dealApiResult(res, () => {
        this.data = res.data
        // this.$refs.table.getLists();
        // this.$commonFun.successTip(res.msg)
      })
    },
  },
  mounted() {
    this.getInfo()

  },
}
</script>

<style scoped lang="less">
.table-con {
  ::-webkit-scrollbar {
    /*滚动条整体样式*/
    width: 15px;
    /*高宽分别对应横竖滚动条的尺寸*/
    height: 15px;
  }

  ::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    border-radius: 10px;
    background-color: skyblue;
    background-image: -webkit-linear-gradient(45deg,
        rgba(255, 255, 255, 0.2) 25%,
        transparent 25%,
        transparent 50%,
        rgba(255, 255, 255, 0.2) 50%,
        rgba(255, 255, 255, 0.2) 75%,
        transparent 75%,
        transparent);
  }

  ::-webkit-scrollbar-track {
    /*滚动条里面轨道*/
    box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    background: #ededed;
    border-radius: 10px;
  }

  .page {
    position: relative;
    margin-top: 10px;
    left: 20px;
  }

  #am_table {
    margin-top: 20px;
    margin-bottom: 20px;
  }
}
</style>